module.exports = __webpack_public_path__ + "static/6-e09f522fc87e654b261f662e4bd567c9.jpg";